import React,{useState, useEffect} from 'react';
import axios from 'axios';
import {databaseUrl} from '../../server/server.js';
import { useLocation } from 'react-router-dom';

import { Button } from '@mui/material';

const ChangeDeposit = () => {
    const location = useLocation();
    const id = location.search.split('=');
    
        let access = localStorage.getItem("accesstoken");
    
        const searchid = Number(id[1]);

        const [notaccess, setNotaccess] = useState('');
        const [number,setNumber] = useState('');
        const [inputdate,setInputDate] = useState('');
        const [company,setCompany] = useState('');
        const [material,setMaterial] = useState('');
        const [weight,setWeight] = useState('');
        const [due_date,setDue_date] = useState('');
        const [isdeposit,setIsdeposit] = useState('');
        const [depositPrice,setdepositPrice] = useState('');
        const [depositDay,setDepositDay] = useState('');
        const [depositSend,setDepositSend] = useState('');
        const [delivery,setDelivery] = useState('');
        const [note,setNote] = useState('');




        useEffect(() => {
         axios.get(`${databaseUrl}/orderboard/find?id=${searchid}`,{
            headers: {Authorization:`Bearer ${access}`},
        }).then((response)=>{
            if(response.data === 'NotAdmin'){
              alert('No access ')
              setNotaccess('You are Not access');
            }else{
                setNumber(response.data.id)
                setInputDate(response.data.inputdate)
                setCompany(response.data.order_company)
                setMaterial(response.data.material)
                setWeight(response.data.material_weight)
                setDue_date(response.data.due_date)
                setIsdeposit(response.data.deposit)
                setdepositPrice(response.data.deposit_price)
                //setDepositDay(response.data.deposit_day)
                setDepositSend(response.data.deposit_send)
                setDelivery(response.data.delivery)
                setNote(response.data.note)

                const getdate = new Date();
                const Year = getdate.getFullYear();
                const Month = getdate.getMonth()+1 < 10 ? '0'+(getdate.getMonth()+1) : getdate.getMonth()+1;
                const Day = getdate.getDate() < 10 ? '0'+getdate.getDate() : getdate.getDate();

                setDepositDay(`${Year}-${Month}-${Day}`)
            }
        }).catch((error)=>{
            const refresh = localStorage.getItem("refreshtoken");
            axios.post(`${databaseUrl}/users/refresh`,{
              headers: {Authorization:`Bearer ${refresh}`},
            },{
    
            }).then( (response)=>{
              localStorage.setItem("accesstoken",response.data.accesstoken);
              localStorage.getItem("refreshtoken",response.data.refreshtoken);
    
              window.location.reload();
        
            }).catch((error) => {alert(error);})
        })
    }, [])

    const sendChangedDeposit = () => {
        const changDate = due_date;
        axios.get(`${databaseUrl}/orderboard/changedeposit?id=${number}&deposit_day=${depositDay}&deposit_send=${depositSend}`,{
            headers: {Authorization:`Bearer ${access}`},
        }).then((response)=>{
            window.open('','_self').close(); 
        })
    }
    return (
        <div>
        <div><h1>{notaccess}</h1></div>
        <table className="table_normal">
            <thead>
            <tr>
                <th>번호</th>
                <th>접수일</th>
                <th>발주처</th>
                <th>품명</th>
                <th>수량</th>
                <th>납기일</th>
                <th>선입금</th>
                <th>선입금액</th>
                <th>입금일</th>
                <th>입금금액</th>
                <th>배송</th>
                <th>비고</th>
            </tr>
            </thead>
            <tbody>
            <tr>
                <td>{number}</td>
                <td>{inputdate.substring(0,10)}</td>
                <td>{company}</td>
                <td>{material}</td>
                <td>{weight}</td>
                <td>{due_date.substring(0,10)}</td>
                <td className='mustinput'>{isdeposit}</td>
                <td className='mustinput'>{depositPrice}</td>
                <td className='mustinput'><input type='date' value={depositDay} onChange={(event)=>setDepositDay(event.target.value)}></input></td>
                <td className='mustinput'><input type='number' onChange={(event)=>setDepositSend(event.target.value)}></input> </td>
                <td>{delivery}</td>
                <td>{note}</td>
            </tr>
            <tr><td colSpan='12'>
                <Button onClick={sendChangedDeposit} size='large' variant="contained" color="success"  sx={{width:'100%'}}>Submit</Button>
            </td>
            </tr>
            </tbody>
        </table>
        </div>
    )
}
export default ChangeDeposit;
